interface SliderProps {
  label: string
  value: number
  min: number
  max: number
  step: number
  format: (value: number) => string
  onChange: (value: number) => void
}

export const Slider = ({label, value, min, max, step, format, onChange}: SliderProps) => (
  <label className="caa-slider">
    <span className="caa-slider-label">{label}</span>
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
    />
    <span className="caa-slider-value">{format(value)}</span>
  </label>
)

interface ColorRowProps {
  label: string
  value: string
  onChange: (value: string) => void
}

export const ColorRow = ({label, value, onChange}: ColorRowProps) => (
  <div className="caa-row">
    <span className="caa-label">{label}</span>
    <input type="color" className="caa-color-input" value={value} onChange={(e) => onChange(e.target.value)} />
  </div>
)
